import React from 'react';
import { signIn } from 'next-auth/react';
import { useRouter } from 'next/router';
import { setCookie } from 'nookies';
import Button from 'components/Button/Button';
import oktaClient from '../data/oktaClient';

const SsoButton = ({ t }) => {
  const { query } = useRouter();

  const handleClick = () => {
    if (query.redirectTo) {
      setCookie(null, 'ov_redirect_to', query.redirectTo, { path: '/', maxAge: 300 });
    }
    signIn(oktaClient.providerId);
  };

  return <Button onClick={handleClick}>{t('use-other-method')}</Button>;
};

export default SsoButton;
